import { useSearchParams } from "react-router-dom";
import { AdminShell } from "../components/admin/AdminShell";
import { StudyContent } from "../components/admin/content/StudyContent";
import { InterviewContent } from "../components/admin/content/InterviewContent";

export default function AdminContent() {
  const [params] = useSearchParams();
  const tab = params.get("tab") === "interview" ? "interview" : "study";
  return (
    <AdminShell active={`content-${tab}`} testid="admin-content-page">
      {tab === "study" ? <StudyContent /> : <InterviewContent />}
    </AdminShell>
  );
}
